import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PositionFromProps } from '../../utils/styledcomponents';
import type { PositionProps } from '../../utils/styledcomponents';
import Image from '../atoms/Image';
import { getSeasonImage } from '../../assets/Assets';
import { getSeasonByIndex } from '../../data/Seasons';

const Container = styled.div`
	align-items: stretch;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	font: ${(props) => props.theme.font.default};
	font-weight: bold;
`;

const Round = styled.span`
	margin-top: 0.4rem;
	font-size: 3vmin;
	text-align: center;
`;

interface Props {
	className?: string;
	currentRoundIndex: number;
	roundCount: number;
}

const CurrentSeasonBar: FunctionComponent<Props> = (props: Props) => {
	const { className, currentRoundIndex, roundCount } = props;

	const seasonImage = useMemo(() => {
		const season = getSeasonByIndex(currentRoundIndex);
		return getSeasonImage(season);
	}, [currentRoundIndex]);

	return (
		<Container className={className}>
			<Image src={seasonImage} width="8vmin" height="8vmin" />
			<Round>
				{currentRoundIndex + 1}/{roundCount}
			</Round>
		</Container>
	);
};

export default styled(CurrentSeasonBar)<PositionProps>(PositionFromProps);
